import PageLinksDsfr from "components/templates/pageLinksDsfr/PageLinksDsfr";
import elementsTypes from "utils/elementsTypes";

export default {
  key: "PAGE_LINKS_DSFR",
  label: "Liste de liens (DSFR)",
  Component: PageLinksDsfr,
  initialContents: [
    {
      key: "headerButtons",
      type: elementsTypes.DYNAMIC_LIST,
      value: "",
      children: [
        {
          key: "limit",
          value: "2",
        },
        { key: "contentType", value: [elementsTypes.BUTTON].toString() },
        { key: "buttonElementText", value: "un bouton" },
      ],
    },
    {
      key: "pageButtons",
      type: elementsTypes.DYNAMIC_LIST,
      value: "",
      children: [
        { key: "contentType", value: [elementsTypes.BUTTON].toString() },
        { key: "buttonElementText", value: "un bouton" },
      ],
    },
    {
      key: "pageLinks",
      type: elementsTypes.DSFR_TILE_CARDS_LIST,
      value: "",
      children: [],
    },
  ],
};
